import React, { useEffect, useState, useCallback } from "react";
import { Box, TextField, Button, Chip, Paper, CircularProgress } from "@mui/material";
import { ConfirmDialog } from "primereact/confirmdialog";
import { getServiceProviderProfile } from "../../Apiservices/Auth/servers/profileServer";
import "./ServiceProviderDashboard.css";
import ServicesList from "./ServicesList";
import CateringService from "./redesigncatering/Cateringservices";
import TentHouseService from "./TentHouseService";
import PriestManageServices from "./PriestManageServices";
import HelperProvider from "./helperprovider/HelperPriceManager";
import VenueService from "./VenueService";
import VenueManageScreen from "./VenueManageScreen";

const ManageServicesTabContent = ({ onActiveTypeChange, initialCategoryId, onClearInitialCategory }) => {
  const [providerServices, setProviderServices] = useState({ types: [] });
  const [loading, setLoading] = useState(true);

  const fetchServiceProviderServices = useCallback(async () => {
    setLoading(true);
    try {
      const { providerTypes } = await getServiceProviderProfile();
      setProviderServices({
        types: providerTypes,
      });
      const hasRentals = providerTypes.some((t) => t.type === "Priest");
      onActiveTypeChange?.(hasRentals ? "Priest" : "Other");
    } catch (error) {
      console.error("Failed to services:", error);
    } finally {
      setLoading(false);
    }
  }, [onActiveTypeChange]);

  useEffect(() => {
    fetchServiceProviderServices();
  }, [fetchServiceProviderServices]);

  const serviceRenderer = (t) => {
    switch (t.type) {
      case "Catering":
        return (
          <CateringService
            providerTypeID={t.id}
            providerLabel={t.type}
            providerDesc={t.description}
          />
        );
      case "Venue Provider":
        return (
          <VenueManageScreen></VenueManageScreen>
          // <VenueService
          //   providerTypeID={t.id}
          //   providerLabel={t.type}
          //   providerDesc={t.description}
          // />
        );
      case "Rentals":
        return (
          <TentHouseService
            providerTypeID={t.id}
            providerLabel={t.type}
            providerDesc={t.description}
          />
        );  
      case "Priest":
        return (
          <PriestManageServices
            providerTypeID={t.id}
            providerLabel={t.type}
            providerDesc={t.description}
            initialCategoryId={initialCategoryId}
            onClearInitialCategory={onClearInitialCategory}
          />
        );
          case "Helper":
        return (
          <HelperProvider
            providerTypeID={t.id}
            providerLabel={t.type}
            providerDesc={t.description}
          />
        );
        
      default:
        return (
          <ServicesList
            providerTypeID={t.id}
            providerLabel={t.type}
            providerDesc={t.description}
          />
        );
    }
  };

  return (
    <>
      <ConfirmDialog />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width:"100%",
            backgroundColor: "#transparent",
          }}
        >
          <CircularProgress />
        </Box>
      ) : providerServices.types.length > 0 ? (
        providerServices.types.map((t) => (
            <div >{serviceRenderer(t)}</div>
        ))
      ) : (
        // <Paper sx={{ p: 2, backgroundColor: "#f8f8f8" }}>
          <div >
            <h4>No Services Available</h4>
          </div>
        // </Paper>
      )}
    </>
  );
};
export default ManageServicesTabContent;
